import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import {
  deleteCoordinate,
  updateCoordinate,
} from "../../../store/reducers/pdfeditor/pdfCoordinatesSlice";
import { Box, Tooltip } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import Draggable from "react-draggable";
import { Resizable } from "re-resizable";
import {
  handleReplaceToggleButton,
  selectVariable,
  updateBoxSize,
} from "../../../store/reducers/pdfeditor/toolsModificationSlice";
import ToolBarImage from "./ToolBarImage";
import { pdfToolApi } from "../../../services/PdfEditor/pdfToolApi";
import zIndex from "@mui/material/styles/zIndex";
import { deletedImagesAdd } from "../../../store/reducers/pdfeditor/deletedImageSlice";
function ImageBox({ enableDargging, coordinate, scale, dimensions, isSelected, onSelect,setSelectedBoxId }) {
  const nodeRef = useRef(null);
  const dispatch = useDispatch();
  console.log("enableDragging in imagebox is", enableDargging);
  const { currBoxSize, replaceToggleButton } = useSelector(
    (state) => state.toolsModification
  );
  const [boxSize, setBoxSize] = useState({
    width: coordinate.width || currBoxSize?.width,
    height: coordinate.height || currBoxSize?.height,
  });
  const [isUploading, setIsUploading] = useState(false);
  const uploadInProgress = useRef(false);

  const [position, setPosition] = useState({
    x: 0,
    y: 0,
    prex: parseInt(coordinate["x-coordinate"]) * scale,
    prey: parseInt(coordinate["y-coordinate"]) * scale,
  });
  useEffect(() => {
    setPosition({
      x: 0,
      y: 0,
      prex: parseInt(coordinate["x-coordinate"]) * scale,
      prey: parseInt(coordinate["y-coordinate"]) * scale,
    });
  }, [coordinate, scale]);
  const [imageUrl, setImageUrl] = useState(coordinate?.imageUrl || "");
  console.log("image url is:", imageUrl);
  const [flag, setFlag] = useState(false);
  const [clickFlag, setClickFlag] = useState(false);

  const widthPdf = dimensions?.width;
  const heightPdf = dimensions?.height;
  // useEffect(() => {
  //   if (!imageUrl) {
  //     handleImageUpload();
  //   }
  // }, [imageUrl]);
  useEffect(() => {
    // Only trigger upload if imageUrl is empty and not already uploading
    if (!imageUrl && !isUploading) {
      handleImageUpload();
    }
  }, [imageUrl]);

  const updateImageCoordinateData = (data) => {
    let url = data;
    console.log("image url to dispatch in imagebox is", data);
    dispatch(
      updateCoordinate({ id: coordinate.id, newValue: { imageUrl: url } })
    );
  };

  const handleSelectBox = (coordinates) => {
    // console.log("coordinates in inputbox handleselectbox is", coordinates);
    // console.log("coordinate in inputbox is", coordinates)
    // setDragBoxDetails(coordinates);
    dispatch(
      selectVariable({
        variable: coordinates.id,
        fontSize: coordinates?.fontSize,
        width: coordinate.width,
        height: coordinate.height,
        boldVal: coordinates?.boldVal,
        italicVal: coordinates?.italicVal,
        data_type: coordinate?.data_type,
        variableName: coordinates?.value,
        fontFamily: coordinates?.fontFamily,
        fontSpace: coordinates?.fontSpace,
      })
    );
    dispatch(
      updateCoordinate({
        id: coordinate.id,
        newValue: {
          boldVal: coordinates?.boldVal,
          italicVal: coordinates?.italicVal,
        },
      })
    );
  };

  const handleStop = (e, data) => {
    console.log("handlestop called")
    const updatedCoordinates = {
      "x-coordinate": (position.prex + data.x) / scale,
      "y-coordinate": (position.prey + data.y) / scale,
    };
    const { width, height } = boxSize || {};
    const xCoord = updatedCoordinates["x-coordinate"] * scale;
    const yCoord = updatedCoordinates["y-coordinate"] * scale;

    // console.log("else xcord and ycord are", xCoord, yCoord, width, height);
    if (
      widthPdf < xCoord + width ||
      widthPdf < 0 ||
      xCoord < 0 ||
        yCoord < 0 ||
      heightPdf < yCoord + height
    ) {
      toast.error(
        "Coordinate should stay within the PDF previewer area when dragging."
      );
      // Reset position to prevent moving out of bounds
      setPosition({
        x: 0,
        y: 0,
        prex: parseInt(coordinate["x-coordinate"]) * scale,
        prey: parseInt(coordinate["y-coordinate"]) * scale,
      });
    } else {
      dispatch(
        updateCoordinate({ id: coordinate.id, newValue: updatedCoordinates })
      );
    }
    onSelect(); // Ensure box is selected on drag stop
  };

  async function deletePreviousImage(imagePath) {
    const response = await pdfToolApi.refreshToken();
    if(response?.access){

      try {
        const response = await pdfToolApi.deleteImage(imagePath,response?.access);
        console.log("response from delete previous image ", response);
      } catch (error) {
        console.log("Error deleting previous image:", error);
      }
    }
  }
  const removeReplaceToggleButton = () => {
    dispatch(handleReplaceToggleButton(false));
  };
  const handleImageUpload = (e) => {
    if (uploadInProgress.current) return;
    if (e?.target?.files[0]) {
      let file = e.target.files[0];
      if (file) {
        const validTypes = ["image/png", "image/jpeg", "image/jpg"];
        if (!validTypes.includes(file.type)) {
          toast.error("Please upload a valid image format (PNG, JPEG, JPG).");
          return;
        }
        setIsUploading(true);
      uploadInProgress.current = true;
        pdfToolApi.refreshToken().then(async (res) => {
          if(res?.access){

            try {
              // Create a FormData object to hold the file
              const formData = new FormData();
              formData.append("media", file);
              console.log("FormData before sending:", formData.get("file"));
  
              // Upload the file to the server
              console.log("FormData before sending:sdf", formData);
              const response = await pdfToolApi.imageUpload(formData,res?.access);
              console.log("Response from server:", response);
              // Get the URL from the server response
              const data = response?.data?.image;
  
              // Update the imageUrl state with the URL
              if (imageUrl) {
                deletePreviousImage(imageUrl);
              }
              setImageUrl(data);
              updateImageCoordinateData(data);
            } catch (error) {
              toast.error("Failed to upload image. Please try again.");
              console.error("Error uploading image:", error);
            } finally {
              setIsUploading(false);
              uploadInProgress.current = false; // Reset the flag after the upload is complete
            }
          }
        });
      }
    } else {
      const fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.accept = "image/png, image/jpeg, image/jpg";
      fileInput.onchange = async (e) => {
        const file = e.target.files[0];
        console.log("file on index 0 is", file);
        if (file) {
          const validTypes = ["image/png", "image/jpeg", "image/jpg"];
          if (!validTypes.includes(file.type)) {
            toast.error("Please upload a valid image format (PNG, JPEG, JPG).");

            return;
          }
          pdfToolApi.refreshToken().then(async (res) => {
            if(res?.access){

              try {
                // Create a FormData object to hold the file
                const formData = new FormData();
                formData.append("media", file);
  
                // Upload the file to the server
                const response = await pdfToolApi.imageUpload(formData,res?.access);
                console.log("Response from server:", response);
                // Get the URL from the server response
                const data = response?.data?.image;
  
                // Update the imageUrl state with the URL
                if (imageUrl) {
                  deletePreviousImage(imageUrl);
                }
                setImageUrl(data);
                updateImageCoordinateData(data);
              } catch (error) {
                toast.error("Failed to upload image. Please try again.");
                console.error("Error uploading image:", error);
              }
            }
          });
        }
      };
      fileInput.click();
    }
  };

  const handleDeleteVariable = (id, imageUrl) => {
    dispatch(deleteCoordinate(id));
    dispatch(deletedImagesAdd(imageUrl));
  };

  const handleResizeStop = (e, direction, ref, d) => {
    // setIsDragging(false)
    setBoxSize({
      width: boxSize.width + d.width,
      height: boxSize.height + d.height,
    });
    dispatch(
      updateBoxSize({
        width: boxSize.width + d.width,
        height: boxSize.height + d.height,
      })
    );
    dispatch(
      updateCoordinate({
        id: coordinate.id,
        newValue: {
          ...coordinate,
          width: boxSize.width + d.width,
          height: boxSize.height + d.height,
        },
      })
    );
  };

  const iconStyle = {
    right: -9,
    zIndex: 3,
    backgroundColor: "transparent",
    padding: "0px",
    width: "14px",
    height: "14px",
    cursor: "pointer",
    position: "absolute",
    left: `${position.prex - 7 + position.x}px`,
    top: `${position.prey - 8 + position.y}px`,
  };
  return (
    <>

      {isSelected && (
        <ToolBarImage
          style={{ ...iconStyle, zIndex: 12 }}
          settedFontSize={coordinate?.fontSize}
          settedFontSpace={coordinate?.fontSpace}
          settedBoxHeight={coordinate?.height}
          settedBoxWidth={coordinate?.width}
          position={position}
          coordinate={coordinate}
          handleImageUpload={handleImageUpload}
          imageUrl={imageUrl}

          setSelectedBoxId={setSelectedBoxId}
        />
      )}

      {!isSelected ? (
        <Draggable
        nodeRef={nodeRef}
        position={position}
        onStart={(e) => {
          // setFlag(true);
          // handleSelectBox(coordinate);
          e.preventDefault(); // Prevent default behavior if needed
        }}
        onStop={handleStop}
        style={{
          width: coordinate.width - 7,
          height: coordinate.height - 6,
          zIndex: 2,
        }}
        // onMouseEnter={() => {
        //   handleSelectBox(coordinate);
        // }}
        onClick={() => onSelect()}
      >
        <Box
          ref={nodeRef}
          style={{
            position: "absolute",
            left: `${position.prex}px`,
            top: `${position.prey}px`,
            border: "1px solid #000",
            cursor: "move",
            height: coordinate.height,
            width: coordinate.width,
            textAlign: "center",
            overflow: "hidden",
            textOverflow: "ellipsis",
            transition: "all 0.1s ease-out",
            display: "flex",
            alignItem: "center",
            justifyContent: "flex-start",
            zIndex: 2,
          }}
        >
          {imageUrl ? (
            <img
              style={{ width: "100%", height: "100%" }}
              src={`https://pdf-uat.meon.co.in/${imageUrl}`}
            />
          ) : (
            "Image"
          )}
        </Box>
      </Draggable>
        
      ) : (
        <Resizable
        style={{
          position: "absolute",
          left: `${position.prex}px`,
          top: `${position.prey}px`,
          height: coordinate.height,
          width: coordinate.width,
          textAlign: "center",
          overflow: "hidden",
          textOverflow: "ellipsis",
          transition: "all 0.1s ease-out",
          fontSize: "15px",
          background: "none",
          outline: "none",
          border: "1px dashed #000000",
          borderRadius: "3px",
          backgroundImage: imageUrl ? `url(${imageUrl})` : "none",
          backgroundSize: "cover",
          backgroundPosition: "center",
          zIndex: 1,
        }}
       //  onMouseEnter={() => {
       //    if (clickFlag) {
       //      return;
       //    }
       //    handleSelectBox(coordinate);
       //    setFlag(true);
       //  }}
       //  onMouseLeave={() => {
       //    if (clickFlag) {
       //      return;
       //    }
       //    setFlag(false);
       //  }}
       //  onClick={() => setClickFlag((prev) => !prev)}
       onMouseEnter={() => onSelect()}
       onMouseLeave={() => onSelect()}
       onClick={() => onSelect()}
       onResizeStart={() => {}}
        onResizeStop={handleResizeStop}
      >
        <Box
          style={{
            height: coordinate.height,
            width: coordinate.width,
            background: "none",
            fontSize: coordinate?.fontSize,
            letterSpacing: coordinate?.fontSpace,
            fontWeight: `${coordinate?.boldVal ? "bold" : "normal"}`,
            fontStyle: `${coordinate?.italicVal ? "italic" : "normal"}`,
            position: "relative",
            fontFamily: coordinate?.fontFamily,
            resize: "none",
            // wordBreak:"break-all",
            overflow: "hidden",
            whiteSpace: "pre-wrap",
          }}
        >
          {/* {!imageUrl && "ImageBox"} */}
          {imageUrl ? (
            <img
              style={{ width: "100%", height: "100%" }}
              src={`https://pdf-uat.meon.co.in/${imageUrl}`}
            />
          ) : (
            <div>
              <input
                type="file"
                accept="image/png, image/jpeg, image/jpg"
                onChange={handleImageUpload}
              />
            </div>
          )}
        </Box>
      </Resizable>
      )}
    </>
  );
}

export default ImageBox;
